import { ref, getCurrentInstance } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useStockVO } from '@rebuild/hooks/useStockVO';
import { deepClone } from '@/utils/api';

export const useQuestionCommon = (options = {}) => {
	const { keyMap = {} } = options;

	const qaKeyMap = {
		'SH': 'e互动',
		'SZ': '互动易',
		...keyMap
	};
	const qaValueMap = {
		'SH': '3',
		'SZ': '3'
	};

	const { question } = useModuleData();
	const { getFullCode } = useStockVO();
	const { proxy } = getCurrentInstance();

	const questionTabList = ref([]);
	const questionTabActValue = ref('');
	let market = getFullCode.value?.slice(0, 2);

	market = market && market.toLocaleUpperCase();

	const queryByTabs = async (tabList = []) => {
		// 没有任何类型的数据 无Tab+缺省图
		const fn = async sourceBiz => {
			await question.refresh({
				sourceBiz,
				pagestart: 0,
				pagenum: 20
			});
			return deepClone(question);
		};

		let tabMap = [];

		tabMap.push({
			label: qaKeyMap[market],
			value: qaValueMap[market]
		});

		tabMap = tabMap.concat([
			{
				label: proxy.$t('enterprise.enquiry'),
				value: '5'
			},
			{
				label: proxy.$t('enterprise.meeting'),
				value: '1'
			},
			{
				label: proxy.$t('enterprise.activities'),
				value: '4'
			}
		]);

		if (tabList.length) {
			tabMap = tabList;
		}

		const checkList = tabMap.map(item => item.value);
		const batchCheckExecute = await Promise.all(checkList.map(sourceBiz => fn(sourceBiz)))
			.then(res => {
				return res.map(r => r.data || {});
			})
			.catch(() => []);

		let renderList = tabMap.map((v, idx) => {
			return {
				...v,
				length: batchCheckExecute[idx]?.rows?.length || 0,
				value: v.value ? v.value : ''
			};
		});
		// 有数据的类型才展示

		// 多种类型 在前面添加全部的Tab
		if (renderList.length > 1 && !tabList.length) {
			// 侧边栏tab从配置项获取,不需要添加全部的Tab
			renderList.unshift({
				label: proxy.$t('enterprise.all'),
				value: ''
			});
		}

		// 只有一种类型的数据 变更文案
		if (renderList.length === 1 && !tabList.length) {
			renderList = [
				{
					label: proxy.$t('enterprise.question'),
					value: renderList?.[0]?.value || ''
				}
			];
		}

		questionTabList.value = renderList;
		console.log('🚀 ~ queryByTabs ~ renderList:', renderList);

		if (questionTabList.value.length > 0) {
			questionTabActValue.value = questionTabList.value[0].value;
		}
	};

	const CODE_FILTER_NAME = {
		1: proxy.$t('enterprise.meeting'),
		3: market == 'SH' ? 'e互动' : '互动易',
		4: proxy.$t('enterprise.activities'),
		5: proxy.$t('enterprise.enquiry')
	};

	return {
		questionTabList,
		questionTabActValue,
		queryByTabs,

		CODE_FILTER_NAME
	};
};
